// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3cSmd","legacyBtn":"MutateMid_legacyBtn__2cpUN"};